export default __webpack_public_path__ + "static/media/Profilo Aziendale FCSI_ITA.81ab80e0.pdf";